import { CheckCircle, ErrorOutline, MarkEmailRead } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { API_URL } from "../../config";

function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Validando seu link de confirmacao...");
  const hasRequestedRef = useRef(false);
  const apiUrl = API_URL?.endsWith("/") ? API_URL : `${API_URL}/`;

  useEffect(() => {
    const token = searchParams.get("token");
    const email = searchParams.get("email");

    if (!apiUrl || apiUrl === "undefined/") {
      setStatus("error");
      setMessage("API nao configurada. Defina REACT_APP_API_URL.");
      return;
    }

    if (!token || !email) {
      setStatus("error");
      setMessage("Link invalido. Token e email sao obrigatorios.");
      return;
    }

    if (hasRequestedRef.current) {
      return;
    }
    hasRequestedRef.current = true;

    const confirmEmail = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}Usuario/confirm-email`,
          { token, email },
        );

        setStatus("success");
        setMessage(response?.data?.message || response?.data?.Message || "Email confirmado com sucesso.");
      } catch (error) {
        setStatus("error");
        setMessage(
          error?.response?.data?.message ||
            error?.response?.data?.Message ||
            "Nao foi possivel confirmar o email. O link pode estar expirado ou invalido.",
        );
      }
    };

    confirmEmail();
  }, [apiUrl, searchParams]);

  return (
    <Box sx={{ minHeight: "70vh", display: "flex", alignItems: "center", py: { xs: 4, md: 6 }, px: { xs: 2, sm: 3 } }}>
      <Container maxWidth="sm" sx={{ px: { xs: 0, sm: 2 } }}>
        <Paper
          elevation={1}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            textAlign: "center",
            maxWidth: { xs: "100%", sm: 480 },
            mx: "auto",
          }}
        >
          {status === "loading" && (
            <Box role="status" aria-live="polite">
              <MarkEmailRead sx={{ fontSize: 56, color: "primary.main", mb: 2 }} />
              <Typography
                variant="h5"
                sx={{ mb: 2, fontWeight: 700, fontSize: { xs: "1.1rem", md: "1.5rem" } }}
              >
                Confirmando email
              </Typography>
              <CircularProgress sx={{ mb: 2 }} />
              <Typography color="text.secondary">{message}</Typography>
            </Box>
          )}

          {status === "success" && (
            <>
              <CheckCircle sx={{ fontSize: 56, color: "success.main", mb: 2 }} />
              <Typography
                variant="h5"
                sx={{ mb: 2, fontWeight: 700, fontSize: { xs: "1.1rem", md: "1.5rem" } }}
              >
                Email confirmado
              </Typography>
              <Alert severity="success" aria-live="polite" sx={{ mb: 3, textAlign: "left" }}>
                {message}
              </Alert>
              <Button
                component={RouterLink}
                to="/login"
                variant="contained"
                size="large"
                fullWidth
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                Ir para login
              </Button>
            </>
          )}

          {status === "error" && (
            <>
              <ErrorOutline sx={{ fontSize: 56, color: "error.main", mb: 2 }} />
              <Typography
                variant="h5"
                sx={{ mb: 2, fontWeight: 700, fontSize: { xs: "1.1rem", md: "1.5rem" } }}
              >
                Falha na confirmacao
              </Typography>
              <Alert severity="error" aria-live="polite" sx={{ mb: 3, textAlign: "left" }}>
                {message}
              </Alert>
              <Button
                component={RouterLink}
                to="/login"
                variant="outlined"
                size="large"
                fullWidth
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                Voltar para login
              </Button>
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
}

export default ConfirmEmail;
